import { Heading, Para, Stack } from '@drycut/ui-components';

import { useCheckoutStore } from '../../checkoutStore';
import { CleanHairInfoButton } from '../../CleanHairInfoButton';
import { SalonSelect } from './SalonSelect';
import WaitingTimeDetails from './WaitingTimeDetails';

type Props = {
  manual: boolean;
};

export function SalonStep({ manual }: Props): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);
  const preSelectedStore = useCheckoutStore((state) => state.preSelectedStore);

  return (
    <>
      {preSelectedStore ? (
        <Heading variant="h3" className="font-ramillas text-start leading-8">
          DRYCUT
          <br />
          {selectedStore?.name}
        </Heading>
      ) : (
        <SalonSelect />
      )}

      {selectedStore && <WaitingTimeDetails store={selectedStore} manual={manual} />}

      {!manual && (
        <Stack
          gap={3}
          direction="row"
          className="bg-primary-50 border-2 border-gray-200 p-2 items-start"
        >
          <Para size="xs">
            Um ein gutes Resultat zu garantieren, bitte beachte unsere "clean hair policy".
            (gewaschen & keine Produkte)
          </Para>

          <CleanHairInfoButton />
        </Stack>
      )}
    </>
  );
}
